import { gql } from '@apollo/client';

export const QUERY_TMS_TRANSPORT_DETAIL_LIST = gql`
    query QueryTmsTransportDetailList($input: TmsTransportDetailPageInput!) {
        queryTmsTransportDetailList(input: $input) {
            content {
                taskNo
                vehicleId
                vehicleName
                carrierName
                vehicleType
                singleVehicleCost
                taskType
                departPackageQty
                departContainerQty
                weightedPackageQty
                fullLoadPackageMaxLimit
                fullLoadWeightMaxLimit
                planOriginDepartTime
                actualOriginDepartTime
                estimateDestArrivalTime
                planDestArrivalTime
                actualDestArrivalTime
                theoryDriveDuration
                actualDriveDuration
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
